function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
  id: "fonePattern",
  preserveAspectRatio: "none",
  width: "100%",
  height: "100%",
  viewBox: "0 0 32 31"
}, /*#__PURE__*/React.createElement("image", {
  width: 32,
  height: 31,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAfCAYAAACGVs+MAAAABHNCSVQICAgIfAhkiAAAAMVJREFUSEvt110OQDAQBGC9vOM5iTuQihWhPzPtTpDwQiL0M7arwjTOw74tdpDYh8K5rlMBBMRBJAgDlJ7enlAGQAaXIWICnwK41wKbwA/4E3DvBWgRug98NBawD0gBEYM0IwniFd+CVyTwGIJZD0i+iGcAmoJrN7wCvBE2u7IzqAdQSyI1tW+QFIBJIVUXVE/JAVoQlggCOFbSJUArglqm1wByBAKQIlCADMEAkF846v1vVXv6NWMupiq9dONWgFca4XHACjzJaNnEplI3AAAAAElFTkSuQmCC"
})));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  id: "fone_icone",
  width: 19.419,
  height: 19,
  fill: "url(#fonePattern)"
});

function SvgFone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.419,
    height: 19,
    viewBox: "0 0 19.419 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFone);
export default __webpack_public_path__ + "static/media/Fone.c5f53308.svg";
export { ForwardRef as ReactComponent };